/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DriverInfoDeviceType,
    DriverInfoDeviceTypeFromJSON,
    DriverInfoDeviceTypeFromJSONTyped,
    DriverInfoDeviceTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface MuDataProcessingModelsDriverInfoDriver
 */
export interface MuDataProcessingModelsDriverInfoDriver {
    /**
     * 
     * @type {DriverInfoDeviceType}
     * @memberof MuDataProcessingModelsDriverInfoDriver
     */
    deviceType: DriverInfoDeviceType;
    /**
     * 
     * @type {string}
     * @memberof MuDataProcessingModelsDriverInfoDriver
     */
    driverToken: string;
    /**
     * 
     * @type {number}
     * @memberof MuDataProcessingModelsDriverInfoDriver
     */
    driverId?: number;
    /**
     * 
     * @type {string}
     * @memberof MuDataProcessingModelsDriverInfoDriver
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof MuDataProcessingModelsDriverInfoDriver
     */
    surname?: string;
    /**
     * 
     * @type {string}
     * @memberof MuDataProcessingModelsDriverInfoDriver
     */
    authType?: string;
    /**
     * 
     * @type {string}
     * @memberof MuDataProcessingModelsDriverInfoDriver
     */
    source?: string;
}

export function MuDataProcessingModelsDriverInfoDriverFromJSON(json: any): MuDataProcessingModelsDriverInfoDriver {
    return MuDataProcessingModelsDriverInfoDriverFromJSONTyped(json, false);
}

export function MuDataProcessingModelsDriverInfoDriverFromJSONTyped(json: any, ignoreDiscriminator: boolean): MuDataProcessingModelsDriverInfoDriver {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'deviceType': DriverInfoDeviceTypeFromJSON(json['device_type']),
        'driverToken': json['driver_token'],
        'driverId': !exists(json, 'driver_id') ? undefined : json['driver_id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'surname': !exists(json, 'surname') ? undefined : json['surname'],
        'authType': !exists(json, 'auth_type') ? undefined : json['auth_type'],
        'source': !exists(json, 'source') ? undefined : json['source'],
    };
}

export function MuDataProcessingModelsDriverInfoDriverToJSON(value?: MuDataProcessingModelsDriverInfoDriver | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'device_type': DriverInfoDeviceTypeToJSON(value.deviceType),
        'driver_token': value.driverToken,
        'driver_id': value.driverId,
        'name': value.name,
        'surname': value.surname,
        'auth_type': value.authType,
        'source': value.source,
    };
}


